// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionListResponse

import { hydrateSession, type Session, type SessionApiResponse } from './session.gen';

export type SessionListApiResponse = {
	items: SessionApiResponse[];
};

export type SessionList = {
	items: Session[];
};

export function hydrateSessionList(data: SessionListApiResponse): SessionList {
	return {
		...data,
		items: data.items.map(hydrateSession),
	};
}